/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2020,2021. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';
export default defineMessages({
  title: {
    id: 'ApplicationVerifications_Title',
    defaultMessage: 'Provide documents as proof'
  },
  documentsRequiredSectionTitle: {
    id: 'ApplicationVerifications_DocumentsRequiredSectionTitle',
    defaultMessage: 'Documents required'
  },
  documentsRequiredSectionSubTitle: {
    id: 'ApplicationVerifications_DocumentsRequiredSectionSubTitle',
    defaultMessage: "Your application (#{applicationRef}) can't be approved until you submit these documents and they are verified by us."
  },
  allDocumentsDueDate: {
    id: 'ApplicationVerifications_DueDate',
    defaultMessage: '{dueDate, select, undefined {All documents} other {All documents due by {dueDate}}}'
  },
  forText: {
    id: 'ApplicationVerifications_ForText',
    defaultMessage: 'For'
  },
  applicationNumber: {
    id: 'ApplicationVerifications_ApplicationNumber',
    defaultMessage: 'Application #'
  },
  informationSubmitted: {
    id: 'ApplicationVerifications_InformationSubmitted',
    defaultMessage: 'Your information is now submitted with reference number {applicationRef}'
  },
  doneSubmitting: {
    id: 'ApplicationVerifications_DoneSubmitting',
    defaultMessage: 'Done submitting documents'
  },
  routeTitle: {
    id: 'ApplicationVerifications_RouteTitle',
    defaultMessage: 'Application verifications'
  },
  iegVerificationDetailsRouteTitle: {
    id: 'ApplicationVerifications_IEGVerificationDetailsRouteTitle',
    defaultMessage: 'Application verifications Details'
  },
  blockBackButton: {
    id: 'ApplicationVerifications_blockBackButton',
    defaultMessage: 'You cannot go back as your application has been submitted. Please call our office to change any details.'
  }
});